module.exports = __webpack_public_path__ + "img/2-13-2.8ae7a12a.png";